import { BASE_URL, getHeaders } from "../utils/serviceHelper";

export const getAllSyllabus = async () => {
    const res = await fetch(
        `${BASE_URL}/syllabus`,
        {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
            headers: getHeaders(),
        },
    );
    return await res.json();
};

